// import { useI18n } from '@/hooks/web/useI18n'
import { Layout } from '@/utils/routerHelper'

const serviceDevelopmentRouter: AppRouteRecordRaw[] = [
  // 服务开发
  {
    path: '/service-development',
    component: Layout,
    name: 'serviceDevelopment',
    meta: {
      icon: 'icon-park-twotone:doc-search',
      title: '数据查看',
      alwaysShow: true,
      permission: ['sd']
    },
    children: [
      {
        path: 'http://10.0.20.247:8088/dashboard/list/',
        name: 'dashboard',
        meta: {
          title: '面板',
          icon: 'carbon:business-metrics',
          type: 'link',
          permission: ['sd:da']
        }
      },
      {
        path: 'http://10.0.20.247:8088/chart/list/',
        name: 'Charts',
        meta: { title: '图表', icon: 'carbon:chart-rose', type: 'link', permission: ['sd:ch'] }
      },
      {
        path: 'http://10.0.20.247:8088/sqllab/',
        name: 'SQL',
        meta: { title: 'SQL开发', icon: 'carbon:code', type: 'link', permission: ['sd:SQL'] }
      }
    ]
  }
]

export default serviceDevelopmentRouter
